module.exports = __webpack_public_path__ + "static/media/start-white-logo-01.61921a92.svg";